import { render } from "./Paginator.vue?vue&type=template&id=003488de"
import script from "./Paginator.vue?vue&type=script&setup=true&lang=js"
export * from "./Paginator.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paginator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "003488de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('003488de', __exports__)) {
    api.reload('003488de', __exports__)
  }
  
  module.hot.accept("./Paginator.vue?vue&type=template&id=003488de", () => {
    api.rerender('003488de', render)
  })

}


export default __exports__